"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VoiceaChannel = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _uuid = _interopRequireDefault(require("uuid"));
var _webexCore = require("@webex/webex-core");
var _constants = require("./constants");
var _utils = require("./utils");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } // eslint-disable-next-line no-unused-vars
/**
 * @description VoiceaChannel to hold single instance of LLM
 * @export
 * @class VoiceaChannel
 */
var VoiceaChannel = exports.VoiceaChannel = /*#__PURE__*/function (_WebexPlugin) {
  (0, _inherits2.default)(VoiceaChannel, _WebexPlugin);
  var _super = _createSuper(VoiceaChannel);
  /**
   * Initializes Voicea plugin
   * @param {any} args
   */
  function VoiceaChannel() {
    var _this;
    (0, _classCallCheck2.default)(this, VoiceaChannel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "namespace", _constants.VOICEA);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "seqNum", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "areCaptionsEnabled", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasSubscribedToEvents", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "vmcDeviceId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "announceStatus", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "captionStatus", void 0);
    /**
     * @param {Object} e
     * @returns {undefined}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "eventProcessor", function (e) {
      _this.seqNum = e.sequenceNumber + 1;
      switch (e.data.relayType) {
        case _constants.AIBRIDGE_RELAY_TYPES.VOICEA.ANNOUNCEMENT:
          _this.vmcDeviceId = e.headers.from;
          _this.announceStatus = _constants.ANNOUNCE_STATUS.JOINED;
          _this.processAnnouncementMessage(e.data.voiceaPayload);
          break;
        case _constants.AIBRIDGE_RELAY_TYPES.VOICEA.TRANSLATION_RESPONSE:
          _this.processCaptionLanguageResponse(e.data.voiceaPayload);
          break;
        case _constants.AIBRIDGE_RELAY_TYPES.VOICEA.TRANSCRIPTION:
          _this.processTranscription(e.data.voiceaPayload);
          break;
        case _constants.AIBRIDGE_RELAY_TYPES.MANUAL.TRANSCRIPTION:
          _this.processManualTranscription(e.data.transcriptPayload);
          break;
        default:
          break;
      }
    });
    /**
     * Process manual Transcript and send alert
     * @param {TranscriptionResponse} transcriptPayload
     * @returns {void}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "processManualTranscription", function (transcriptPayload) {
      switch (transcriptPayload.type) {
        case _constants.TRANSCRIPTION_TYPE.MANUAL_CAPTION_FINAL_RESULT:
        case _constants.TRANSCRIPTION_TYPE.MANUAL_CAPTION_INTERIM_RESULTS:
          // @ts-ignore
          _this.trigger(_constants.EVENT_TRIGGERS.NEW_MANUAL_CAPTION, {
            isFinal: transcriptPayload.type === _constants.TRANSCRIPTION_TYPE.MANUAL_CAPTION_FINAL_RESULT,
            transcriptId: transcriptPayload.id,
            transcripts: transcriptPayload.transcripts
          });
          break;
        default:
          break;
      }
    });
    /**
     * Process Transcript and send alert
     * @param {TranscriptionResponse} voiceaPayload
     * @returns {void}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "processTranscription", function (voiceaPayload) {
      switch (voiceaPayload.type) {
        case _constants.TRANSCRIPTION_TYPE.TRANSCRIPT_INTERIM_RESULTS:
          // @ts-ignore
          _this.trigger(_constants.EVENT_TRIGGERS.NEW_CAPTION, {
            isFinal: false,
            transcriptId: voiceaPayload.transcript_id,
            transcripts: voiceaPayload.transcripts
          });
          break;
        case _constants.TRANSCRIPTION_TYPE.TRANSCRIPT_FINAL_RESULT:
          // @ts-ignore
          _this.trigger(_constants.EVENT_TRIGGERS.NEW_CAPTION, {
            isFinal: true,
            transcriptId: voiceaPayload.transcript_id,
            transcripts: voiceaPayload.transcripts.map(function (transcript) {
              transcript.timestamp = (0, _utils.millisToMinutesAndSeconds)(transcript.end_millis);
              return transcript;
            })
          });
          break;
        case _constants.TRANSCRIPTION_TYPE.HIGHLIGHT_CREATED:
          // @ts-ignore
          _this.trigger(_constants.EVENT_TRIGGERS.HIGHLIGHT_CREATED, {
            csis: voiceaPayload.highlight.csis,
            highlightId: voiceaPayload.highlight.highlight_id,
            text: voiceaPayload.highlight.transcript,
            highlightLabel: voiceaPayload.highlight.highlight_label,
            highlightSource: voiceaPayload.highlight.highlight_source,
            timestamp: (0, _utils.millisToMinutesAndSeconds)(voiceaPayload.highlight.end_millis)
          });
          break;
        case _constants.TRANSCRIPTION_TYPE.EVA_THANKS:
          // @ts-ignore
          _this.trigger(_constants.EVENT_TRIGGERS.EVA_COMMAND, {
            isListening: false,
            text: voiceaPayload.command_response
          });
          break;
        case _constants.TRANSCRIPTION_TYPE.EVA_WAKE:
        case _constants.TRANSCRIPTION_TYPE.EVA_CANCEL:
          // @ts-ignore
          _this.trigger(_constants.EVENT_TRIGGERS.EVA_COMMAND, {
            isListening: voiceaPayload.type === _constants.TRANSCRIPTION_TYPE.EVA_WAKE
          });
          break;
        default:
          break;
      }
    });
    /**
     * Processes Caption Language Response
     * @param {CaptionLanguageResponse} voiceaPayload
     * @returns {void}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "processCaptionLanguageResponse", function (voiceaPayload) {
      if (voiceaPayload.statusCode === 200) {
        // @ts-ignore
        _this.trigger(_constants.EVENT_TRIGGERS.CAPTION_LANGUAGE_UPDATE, {
          statusCode: 200
        });
      } else {
        // @ts-ignore
        _this.trigger(_constants.EVENT_TRIGGERS.CAPTION_LANGUAGE_UPDATE, {
          statusCode: voiceaPayload.errorCode,
          errorMessage: voiceaPayload.message
        });
      }
    });
    /**
     * processes voicea announcement response and triggers event
     * @param {Object} voiceaPayload
     * @returns {void}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "processAnnouncementMessage", function (voiceaPayload) {
      var _voiceaPayload$transl, _voiceaPayload$transl2, _voiceaPayload$transl3, _voiceaPayload$transl4, _voiceaPayload$ASR$sp, _voiceaPayload$ASR;
      var voiceaLanguageOptions = {
        captionLanguages: (_voiceaPayload$transl = voiceaPayload === null || voiceaPayload === void 0 ? void 0 : (_voiceaPayload$transl2 = voiceaPayload.translation) === null || _voiceaPayload$transl2 === void 0 ? void 0 : _voiceaPayload$transl2.allowed_languages) !== null && _voiceaPayload$transl !== void 0 ? _voiceaPayload$transl : [],
        maxLanguages: (_voiceaPayload$transl3 = voiceaPayload === null || voiceaPayload === void 0 ? void 0 : (_voiceaPayload$transl4 = voiceaPayload.translation) === null || _voiceaPayload$transl4 === void 0 ? void 0 : _voiceaPayload$transl4.max_languages) !== null && _voiceaPayload$transl3 !== void 0 ? _voiceaPayload$transl3 : 0,
        spokenLanguages: (_voiceaPayload$ASR$sp = voiceaPayload === null || voiceaPayload === void 0 ? void 0 : (_voiceaPayload$ASR = voiceaPayload.ASR) === null || _voiceaPayload$ASR === void 0 ? void 0 : _voiceaPayload$ASR.spoken_languages) !== null && _voiceaPayload$ASR$sp !== void 0 ? _voiceaPayload$ASR$sp : []
      };

      // @ts-ignore
      _this.trigger(_constants.EVENT_TRIGGERS.VOICEA_ANNOUNCEMENT, voiceaLanguageOptions);
    });
    /**
     * Sends Announcement to add voicea to the meeting
     * @returns {void}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "sendAnnouncement", function () {
      _this.announceStatus = _constants.ANNOUNCE_STATUS.JOINING;
      _this.listenToEvents();
      // @ts-ignore
      _this.webex.internal.llm.socket.send({
        id: "".concat(_this.seqNum),
        type: 'publishRequest',
        recipients: {
          // @ts-ignore
          route: _this.webex.internal.llm.getBinding()
        },
        headers: {},
        data: {
          clientPayload: {
            version: 'v2'
          },
          eventType: 'relay.event',
          relayType: _constants.AIBRIDGE_RELAY_TYPES.VOICEA.CLIENT_ANNOUNCEMENT
        },
        trackingId: "".concat(_webexCore.config.trackingIdPrefix, "_").concat(_uuid.default.v4().toString())
      });
      _this.seqNum += 1;
    });
    /**
     * Set Spoken Language for the meeting
     * @param {string} languageCode
     * @returns {Promise}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setSpokenLanguage", function (languageCode) {
      return (
        // @ts-ignore
        _this.request({
          method: 'PUT',
          // @ts-ignore
          url: "".concat(_this.webex.internal.llm.getLocusUrl(), "/controls/"),
          body: {
            transcribe: {
              spokenLanguage: languageCode
            }
          }
        }).then(function () {
          // @ts-ignore
          _this.trigger(_constants.EVENT_TRIGGERS.SPOKEN_LANGUAGE_UPDATE, {
            languageCode: languageCode
          });
        })
      );
    });
    /**
     * Request Language translation
     * @param {string} languageCode
     * @returns {void}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "requestLanguage", function (languageCode) {
      // @ts-ignore
      if (!_this.webex.internal.llm.isConnected()) return;
      // @ts-ignore
      _this.webex.internal.llm.socket.send({
        id: "".concat(_this.seqNum),
        type: 'publishRequest',
        recipients: {
          // @ts-ignore
          route: _this.webex.internal.llm.getBinding()
        },
        headers: {
          to: _this.vmcDeviceId
        },
        data: {
          clientPayload: {
            translationLanguage: languageCode,
            id: _uuid.default.v4()
          },
          eventType: 'relay.event',
          relayType: _constants.AIBRIDGE_RELAY_TYPES.VOICEA.TRANSLATION_REQUEST
        },
        trackingId: "".concat(_webexCore.config.trackingIdPrefix, "_").concat(_uuid.default.v4().toString())
      });
      _this.seqNum += 1;
    });
    /**
     * request turn on Captions
     * @param {string} [languageCode] - Optional Parameter for spoken language code. Defaults to English
     * @returns {Promise}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "requestTurnOnCaptions", function (languageCode) {
      _this.captionStatus = _constants.TURN_ON_CAPTION_STATUS.SENDING;

      // only set the spoken language if it is provided
      var body = {
        transcribe: {
          caption: true
        },
        languageCode: languageCode
      };

      // @ts-ignore
      // eslint-disable-next-line newline-before-return
      return _this.request({
        method: 'PUT',
        // @ts-ignore
        url: "".concat(_this.webex.internal.llm.getLocusUrl(), "/controls/"),
        body: body
      }).then(function () {
        // @ts-ignore
        _this.trigger(_constants.EVENT_TRIGGERS.CAPTIONS_TURNED_ON);
        _this.areCaptionsEnabled = true;
        _this.captionStatus = _constants.TURN_ON_CAPTION_STATUS.ENABLED;
        _this.announce();
      }).catch(function () {
        _this.captionStatus = _constants.TURN_ON_CAPTION_STATUS.IDLE;
        throw new Error('turn on captions fail');
      });
    });
    /**
     * is announce processing
     * @returns {boolean}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isAnnounceProcessing", function () {
      return [_constants.ANNOUNCE_STATUS.JOINING, _constants.ANNOUNCE_STATUS.JOINED].includes(_this.announceStatus);
    });
    /**
     * announce to voicea data chanel
     * @returns {void}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "announce", function () {
      if (_this.isAnnounceProcessing()) return;
      // @ts-ignore
      if (!_this.webex.internal.llm.isConnected()) {
        throw new Error('voicea can not announce before llm connected');
      }
      _this.sendAnnouncement();
    });
    /**
     * is turn on caption processing
     * @returns {boolean}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isCaptionProcessing", function () {
      return [_constants.TURN_ON_CAPTION_STATUS.SENDING, _constants.TURN_ON_CAPTION_STATUS.ENABLED].includes(_this.captionStatus);
    });
    /**
     * Turn on Captions
     * @param {string} [spokenLanguage] - Optional Spoken language code
     * @returns {Promise}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "turnOnCaptions", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(spokenLanguage) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this.isCaptionProcessing()) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", undefined);
            case 2:
              if (_this.webex.internal.llm.isConnected()) {
                _context.next = 4;
                break;
              }
              throw new Error('can not turn on captions before llm connected');
            case 4:
              return _context.abrupt("return", _this.requestTurnOnCaptions(spokenLanguage));
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    /**
     * Toggle transcribing for highlights
     * @param {bool} activate if true transcribing is turned on
     * @param {string} spokenLanguage language code for spoken language
     * @returns {Promise}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleTranscribing", function (activate, spokenLanguage) {
      // @ts-ignore
      return _this.request({
        method: 'PUT',
        // @ts-ignore
        url: "".concat(_this.webex.internal.llm.getLocusUrl(), "/controls/"),
        body: {
          transcribe: {
            transcribing: activate
          },
          spokenLanguage: spokenLanguage
        }
      }).then(function () {
        if (activate && !_this.areCaptionsEnabled) {
          return _this.turnOnCaptions(spokenLanguage);
        }
        return undefined;
      });
    });
    /**
     * Toggle turn on manual caption
     * @param {bool} enable if true manual caption is turned on
     * @returns {Promise}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleManualCaption", function (enable) {
      // @ts-ignore
      return _this.request({
        method: 'PUT',
        // @ts-ignore
        url: "".concat(_this.webex.internal.llm.getLocusUrl(), "/controls/"),
        body: {
          manualCaption: {
            enable: enable
          }
        }
      }).then(function () {
        return undefined;
      });
    });
    /**
     * get caption status
     * @returns {string}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getCaptionStatus", function () {
      return _this.captionStatus;
    });
    /**
     * get announce status
     * @returns {string}
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getAnnounceStatus", function () {
      return _this.announceStatus;
    });
    _this.seqNum = 1;
    _this.areCaptionsEnabled = false;
    _this.vmcDeviceId = undefined;
    _this.announceStatus = _constants.ANNOUNCE_STATUS.IDLE;
    _this.captionStatus = _constants.TURN_ON_CAPTION_STATUS.IDLE;
    return _this;
  }
  (0, _createClass2.default)(VoiceaChannel, [{
    key: "listenToEvents",
    value:
    /**
     * Listen to websocket messages
     * @returns {undefined}
     */
    function listenToEvents() {
      if (!this.hasSubscribedToEvents) {
        // @ts-ignore
        this.webex.internal.llm.on('event:relay.event', this.eventProcessor);
        this.hasSubscribedToEvents = true;
      }
    }

    /**
     * Listen to websocket messages
     * @returns {void}
     */
  }, {
    key: "deregisterEvents",
    value: function deregisterEvents() {
      this.areCaptionsEnabled = false;
      this.vmcDeviceId = undefined;
      // @ts-ignore
      this.webex.internal.llm.off('event:relay.event', this.eventProcessor);
      this.hasSubscribedToEvents = false;
      this.announceStatus = _constants.ANNOUNCE_STATUS.IDLE;
      this.captionStatus = _constants.TURN_ON_CAPTION_STATUS.IDLE;
    }
  }]);
  return VoiceaChannel;
}(_webexCore.WebexPlugin);
var _default = exports.default = VoiceaChannel;
//# sourceMappingURL=voicea.js.map
